import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService } from 'src/app/services/alert.service';
import { UserSessionService } from 'src/app/services/usersession.service';
import { PasswordStrengthValidator } from 'src/app/views/layout/validators/password-strength.validators';
import { UserService } from 'src/app/services/user.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
  selector: 'app-changerole',
  templateUrl: './changerole.component.html',
  styleUrls: ['./changerole.component.scss']
})
export class ChangeRoleComponent implements OnInit {
  form: FormGroup;
  returnUrl: string;
  abcd: number;
  eventData: any;
  userId: number;
  show: boolean;
  show2: boolean;
  showold: boolean;
  captchacode: string;
  roleList: any[] = [];
  roleListCopy: any[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private userService: UserService,
    private alertService: AlertService,
    public dialogRef: MatDialogRef<ChangeRoleComponent>,
    private userSessionService: UserSessionService,
    ) {
    if (this.data) {
      this.roleListCopy = data.role;
      this.roleList = data.role;
    }
  }

  ngOnInit() {
    this.initializeValidators();
  }

  initializeValidators() {
    this.form = new FormGroup({
      roleId: new FormControl('', [Validators.required]),
    });
  }

 
  onSave() {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value.roleId);
    } else {
      this.validateFormControl();
    }
  }

  onCancel() {
    this.dialogRef.close();
  }

  validateFormControl() {
    Object.keys(this.form.controls).forEach(field => {
      const control = this.form.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({
          onlySelf: true
        });
      }
    })
  }

}
